
import {IBouquet} from "./types";

const API_BASE = (typeof window !== 'undefined' && (window as any).REACT_APP_API_URL) || (typeof process !== 'undefined' && process.env?.REACT_APP_API_URL) || '/api';
const URL = `${API_BASE}/bouquets`;
const headers = {
    'Content-Type': 'application/json',
}

const calculatePostPage = (totalCount: number, limit: number) => Math.floor(totalCount / limit)

export const bouquetsAPI = {
    getAll: async (page?: number, limit?: number): Promise<IBouquet[] | undefined> => {
        const response = await fetch(URL)
        return response.json();
    },
    getById: (id: string) => {
        return fetch(`${URL}/${id}`)
            .then((response) => response.json())
    },
    add: (task: any) => {
        return fetch(URL, {
            method: 'POST',
            headers,
            body: JSON.stringify(task),
        })
            .then((response) => response.json())
    },
    delete: (id: string) => {
        return fetch(`${URL}/${id}`, { method: 'DELETE' })
    },
    sync: async (): Promise<{ message: string; count: number }> => {
        const response = await fetch(`${URL}/sync`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        return response.json();
    },
}

